import TmrBaseResource from './TmrBaseResource'

export default class RepairManagers extends TmrBaseResource {
  static endpoint = '/repairManager'
}
